export default __webpack_public_path__ + "static/media/validationDialog.fe91733f.svg";